export default __webpack_public_path__ + "static/media/primary.3607c8ea.png";